import Application from "../../Application";
import LegalViewTypesPresenter, {
  ILegalViewTypesPresenter
} from "../presenter/LegalViewTypesPresenter";
import GetAllLegalViewTypesInteractor from "./GetAllLegalViewTypesInteractor";

export default class ShowLegalViewTypeInteractor {
  private application: Application;
  private output?: ILegalViewTypesPresenter;
  private getAllLegalViewTypesInteractor: GetAllLegalViewTypesInteractor;

  constructor({ application, getAllLegalViewTypes }) {
    this.application = application;
    this.getAllLegalViewTypesInteractor = getAllLegalViewTypes;
  }

  execute() {
    this.output = LegalViewTypesPresenter({
      application: this.application,

      initialState: { legalViewTypes: [] }
    });
    this.getAllLegalViewTypesInteractor
      .execute()
      .then(this.output.loadAllLegalViewTypes);
    return this.output;
  }
}
